addEventListener('load', () => {
    let sectionCurrent = document.querySelector('.rocket-tabs-ajax'),
    sectionAfter = getSiblings(sectionCurrent);

    for (i = 0; i < sectionAfter.after.length; i++) {
        sectionAfter.after[i].style.display = "none"

        wrapAjax(sectionAfter.after[i]);

        sectionAfter.after[i].style.display = "block"
    }

    let url = window.location.pathname;
    let link = document.getElementById(url);
    
    if (link) {
        link.click();
    } else {
        let firstMenuLink = document.querySelector('.menu-link');
        if (firstMenuLink) {
            firstMenuLink.click();
        }
    }
  
    initalSlider();
})

window.addEventListener('scroll', function() {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  let elementTab = document.querySelector('.tabs-ajax');

  if (currentScroll > 0) {
    elementTab.classList.add('header-tags-height');
  } else {
    elementTab.classList.remove('header-tags-height');
  }
});

const getSiblings = (elm, withTextNodes) => {
    if( !elm || !elm.parentNode ) return
    
    let siblings = [...elm.parentNode[withTextNodes ? 'childNodes' : 'children']],
        idx = siblings.indexOf(elm);

    siblings.after = siblings.slice(idx + 1)
    return siblings
}

function wrapAjax(el) {
    let wrapper = document.querySelector('.tabs-ajax--content');
    wrapper.append(el)
}

function tabAjax(e, url) {
    let wrapper = document.querySelector('.tabs-ajax--content'),
        urlFetch = url;
    if (!e.classList.contains('active-link') || !e.classList.contains('active-link-punto')) {
        document.querySelectorAll('.tabs-ajax--tab .menu-link').forEach((links) => { 
            links.classList.remove('active-link');
            links.classList.remove('active-link-punto');
        });
        if (url == '/pages/coleccion-camisas' || url == '/pages/sastreria-a-medida' || url == '/pages/coleccion-trajes' || url == '/pages/listado-de-tiendas' || url == '/pages/guia-de-estio-by-scalpers') {
            e.classList.add('active-link-punto');
        } else {
            e.classList.add('active-link');
        }

        wrapper.innerHTML = '';
            
        fetch(urlFetch)
            .then(function(response) {
                return response.text()
            })
            .then(function(html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
        
                let body = doc.querySelector('.rocket-tabs-ajax');
                const elmSiblings = getSiblings(body)
                
                for (i = 0; i < elmSiblings.after.length; i++) {
                    wrapAjax(elmSiblings.after[i]);

                    elmSiblings.after[i].querySelectorAll('script').forEach((item) => {
                        let script_tag = document.createElement('script');
                        script_tag.innerHTML = item.innerHTML;

                        wrapper.append(script_tag);
                    })
                }
            })
            .catch(function(err) {  
                console.log('Failed to fetch page: ', err);  
            });
    }
}

function initalSlider() {
    let section = document.querySelector('.rocket-tabs-ajax'),
        inner = document.querySelector('.tabs-ajax--innner'),
        tab = document.querySelector('.tabs-ajax--tab');

    if (section && inner && tab) {
        section.classList.remove('opacity-0')
    }
}